import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { AppService } from 'src/app/Services/app.service';
import { ContentComponent } from '../content/content.component';
import { ContentService } from '../content/content.service';
import { NavService } from '../nav.service';
import { NavItem } from '../nav-item';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
  ],
})

export class MenuListItemComponent implements OnInit {

  loggedUserId: any;
  PRCount: any;
  selectedFilter: any;
  list: any;
  resourceCount: any;
  expanded!: boolean;

  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item!: NavItem;
  @Input() depth!: number;

  constructor(
    public appService: AppService,
    public navService: NavService,
    public router: Router,
    private content: ContentComponent,
    private contentService: ContentService,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.loggedUserId = sessionStorage.getItem("id")
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item!.route && url) {
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
      }
    });
    this.contentService.getPRCountEmitter().subscribe((data) => {
      this.PRCount = data;
    })
    this.contentService.getResourceCountEmitter().subscribe((data) => {
      this.resourceCount = data;
    })
  }

  onItemSelected(item: NavItem) {
    this.appService.chageParentMenuData(item);
    sessionStorage.setItem('currentMenu', JSON.stringify(item));
    if (!item.children || !item.children.length) {
      if (item.route == null || item.route == undefined) {
        item.route = '';
      }
      this.router.navigate([item.route]);
      this.navService.closeNav();
      this.content.closeSideNav();
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
